<template>
  <div class="row">
    <div class="col-12 text-center">
      <span class="avisoApp">FUNÇÕES QUE USAM A CÂMERA OU MICROFONE SÓ FUNCIONA COM O CELULAR!</span>
    </div>

    <div class="col-12 text-center mt-4" v-if="loading == true">
      <iframe :src="url" class="cardApp" frameborder="0" width="450px" height="800px"></iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'VerMeuApp',

  computed: {
    ...mapState(['dadosUsuario']),
  },

  data() {
    return {
      loading: false,
      url: ''
    };
  },

  created() {
    const userId = this.$route.meta.userType == UserTypes.BALCONISTA
      ? this.dadosUsuario.construp_user_id
      : this.dadosUsuario.id;
  
    this.url = `http://web-app.construp.com.br?lojista_id=${userId}`;
    
    this.loading = true;
  }
};
</script>

<style scoped>
.avisoApp {
  font-size: 25px;
  color: red;
  font-weight: bold;
  border: none;
  padding: 5px 30px;
}

.cardApp {
  border: 10px solid #000;
  border-radius: 4px;
  width: 450px;
  height: 800px;
}
@media (max-width: 500px) {
  .avisoApp {
    font-size: 19px;
  }

  .cardApp {
    border: 10px solid #000;
    border-radius: 4px;
    width: 90%;
    height: 600px;
  }
}
</style>